import primaryComponents from "../../../../primaryComponents";
import React from "react";
import useValidation from "./useValidation";
import { useConnectTerminal } from "./useConnectTerminal";
import secondaryComponents from "../../..";

export const ConnectTerminal = ({
  fieldProps = {},
  providerprops = {},
  terminalType,
  ...rest
}) => {
  const allFields = fieldProps?.fieldList;
  const {
    storeList,
    formDetails,
    isConnecting,
    isFetchingAccount,
    interswitchAccounts,
    setFormDetails,
    connectTerminal,
  } = useConnectTerminal({
    fieldProps,
    terminalType,
    ...rest,
  });

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useValidation({
    ...formDetails,
    terminalType,
    providerFields: allFields?.map((item) => {
      return item?.isRequired ? item?.key : "null";
    }),
  });

  return (
    <form
      id={fieldProps?.name}
      onSubmit={handleSubmit(connectTerminal)}
      style={{ margin: "auto", maxWidth: "700px" }}
    >
      {providerprops?.hasDynamicAccount && (
        <div className={"mb-3"}>
          <label>
            <span className="error--text">*</span>Account Number Type
          </label>

          <div className={"d-flex"} style={{ columnGap: "15px" }}>
            <primaryComponents.BoxedRadioInput
              name={"accountType"}
              classNames="align-items-start"
              style={{ minHeight: "50px", height: "auto" }}
              isChecked={formDetails?.use_static_account}
              isControlled={true}
              setRadioValue={() =>
                setFormDetails((prevState) => ({
                  ...prevState,
                  use_static_account: true,
                }))
              }
            >
              <span className="mt-1 d-block">
                <span className="d-flex mb-1">Static</span>

                <span className="gray--text smallest-text-size">
                  Assign static account number to this terminal
                </span>
              </span>
            </primaryComponents.BoxedRadioInput>
            <primaryComponents.BoxedRadioInput
              name={"accountType"}
              classNames="align-items-start"
              style={{ minHeight: "50px", height: "auto" }}
              isControlled={true}
              isChecked={!formDetails?.use_static_account}
              setRadioValue={() =>
                setFormDetails((prevState) => ({
                  ...prevState,
                  use_static_account: false,
                }))
              }
            >
              <span className="mt-1 d-block">
                <span className="d-flex mb-1">Dynamic</span>

                <span className="gray--text smallest-text-size">
                  Assign dynamic account number to this terminal
                </span>
              </span>
            </primaryComponents.BoxedRadioInput>
          </div>
        </div>
      )}

      {terminalType === "INTERSWITCH" ? (
        <secondaryComponents.LoaderHelper isLoading={isFetchingAccount}>
          <primaryComponents.SelectFieldV2
            control={control}
            name="interswitch_account_id"
            label="Interswitch Account"
            options={interswitchAccounts}
            idKey="id"
            nameKey="merchant_name"
            isRequired
            onChange={(value) => {
              setFormDetails((prevState) => ({
                ...prevState,
                interswitch_account_id: value,
              }));
            }}
            value={
              interswitchAccounts?.find(
                (account) =>
                  `${account?.id}` === `${formDetails?.interswitch_account_id}`,
              )?.merchant_name || "Select account"
            }
            classNames="store-select"
            isSearchable={false}
            errorMessage={errors.interswitch_account_id}
          />
        </secondaryComponents.LoaderHelper>
      ) : null}

      {allFields?.map((field, index) => {
        return (
          <React.Fragment key={index}>
            <primaryComponents.InputFieldV2
              control={control}
              classNames="white"
              label={field?.label}
              placeholder={`Enter ${field?.label}`}
              name={field?.key}
              value={formDetails?.[field?.key]}
              isRequired={field?.isRequired}
              register={register}
              errorMessage={errors?.[field?.key]}
              onKeyUp={() =>
                errors?.[field?.key] !== undefined && trigger(field?.key)
              }
              onChange={({ target: { value } }) => {
                setFormDetails((prevState) => ({
                  ...prevState,
                  [field?.key]: value,
                }));
              }}
            />
          </React.Fragment>
        );
      })}

      <primaryComponents.SelectFieldV2
        control={control}
        name="store_id"
        label="Store"
        options={storeList}
        idKey="id"
        nameKey="name"
        isRequired
        onChange={(value) => {
          setFormDetails((prevState) => ({
            ...prevState,
            store_id: value,
          }));
        }}
        value={
          storeList?.find(
            (store) => `${store?.id}` === `${formDetails?.store_id}`,
          )?.name || "Select stores"
        }
        classNames="store-select"
        isSearchable={false}
        errorMessage={errors.store_id}
      />

      <div className="d-flex align-items-center">
        <primaryComponents.Checkbox
          name={"isEnabledOnCheckout"}
          id={"isEnabledOnCheckout"}
          isChecked={formDetails?.use_on_checkout}
          onChange={() =>
            setFormDetails((prev) => ({
              ...prev,
              use_on_checkout: !formDetails?.use_on_checkout,
            }))
          }
        />
        <label htmlFor="isEnabledOnCheckout" className="mt-1 cursor-pointer">
          Enable {providerprops?.primaryName} terminal on checkout
        </label>
      </div>

      <primaryComponents.Button
        classNames={"ml-auto btn btn--primary"}
        style={{ width: "200px" }}
        type="submit"
        isDisabled={isConnecting}
        isLoading={isConnecting}
        loadingText={"Connecting..."}
      >
        Proceed
      </primaryComponents.Button>
    </form>
  );
};
